import React from 'react'
import classNames from 'classnames'

export const Button = ({ className, onClick, children, ...otherProps }) => (
  <button
    className={ classNames("button", className) }
    onClick={ event => onClick() } 
    children={ children }
    { ...otherProps } />
)


// WEBPACK FOOTER //
// ./src/ui/elements/Button.js